import Vouchers from '../../services/vouchers.service';
import { showSnackBar } from './snackbar.actions';

/** Action types **/
export const SET_VOUCHERS_LIST = '[VOUCHERS] SET LIST';

//--------------------------
/** Actions **/

/**
 *
 * @param {Object} paginatedVouchers
 */
export const setVouchersList = paginatedVouchers => {
  return {
    type: SET_VOUCHERS_LIST,
    paginatedVouchers,
  };
};

//--------------------------
/** Action creators **/

export const getVouchersList = filters => {
  return dispatch => {
    Vouchers.listVouchers(filters)
      .then(response => {
        dispatch(
          setVouchersList({
            items: response.data,
            totalCount: response.data.length,
          }),
        );
      })
      .catch(() => {
        dispatch(
          showSnackBar({
            message: 'Could not load the list of vouchers',
            type: 'error',
          }),
        );
      });
  };
};
